import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const AttachFileIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        height="20"
        width="20"
        viewBox="0 0 20 20"
        fill={theme.colors.primary.variant8}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9.5 18q-1.917 0-3.208-1.365Q5 15.271 5 13.375V5.271q0-1.354.948-2.313Q6.896 2 8.25 2q1.396 0 2.323 1.01.927 1.011.927 2.386v7.625q0 .833-.594 1.406T9.5 15q-.875 0-1.438-.625-.562-.625-.562-1.458V5H9v8.021q0 .208.146.354t.354.146q.208 0 .354-.146t.146-.354v-7.75q0-.729-.51-1.25Q8.979 3.5 8.25 3.5t-1.24.531q-.51.531-.51 1.281v8.209q0 1.25.885 2.114.886.865 2.115.865 1.292 0 2.146-.917.854-.916.854-2.166V5H14v8.521q0 1.875-1.302 3.177T9.5 18Z" />
      </svg>
    </Icon>
  );
};

export default AttachFileIcon;
